/**
 * Contratos de Intelligence KPIs (Edge / gateway). Sin I/O.
 */

export type IntelligenceKpisPreset = 'today' | 'yesterday' | 'week' | 'custom';

export type RentabilidadDailyRow = {
  day: string;
  salesCount: number;
  salesTotal: number;
  costoReposicionTotal: number;
  margenReposicionTotal: number;
  rentabilidadReposicionPct: number;
};

export type TurnoKpiHistoryRow = {
  cashSessionId: string;
  closedAt: string;
  diferenciaCaja: number;
  expectedAmount: number;
  closingAmount: number;
  ventasTotal: number;
  ventasCount: number;
  costoReposicionTotal: number;
  margenReposicionTotal: number;
  rentabilidadReposicionPct: number;
};

export type IntelligenceKpisResponse = {
  ok: boolean;
  range: { preset: string; fromIso: string; toIso: string };
  rentabilidad: {
    salesTotal: number;
    salesCount: number;
    costoReposicionTotal: number;
    margenReposicionTotal: number;
    rentabilidadReposicionPct: number;
  };
  rentabilidadDaily: RentabilidadDailyRow[];
  turnos: {
    turnosCount: number;
    diferenciaTotal: number;
    diferenciaPromedio: number;
    tasaDiferencia: number;
    ventasTotal: number;
    ventasCount: number;
    costoReposicionTotal: number;
    margenReposicionTotal: number;
    rentabilidadReposicionPct: number;
    history: TurnoKpiHistoryRow[];
  };
};

/** Error interno: sesión inválida o expirada (mapear en UI a mensaje amable). */
export const INTELLIGENCE_SESSION_ERROR = 'INTELLIGENCE_SESSION_ERROR';
